import { urlForImage } from '@/lib/sanity/sanity';
import { useMemo } from 'react';
import { ExperienceItem, PaletteType } from '../types';

export function useImagePaletteData(experienceItems: ExperienceItem[]) {
  const data: Array<PaletteType> = useMemo(() => {
    const data = experienceItems
      .map((project) => {
        return project.caseItems.map((item) => {
          if (item?.image?.asset) {
            const parsed = {
              ...item,
              title: project.title,
              slug: project.slug,
              image: `https://www.cleverfranke.com/_next/image?url=${urlForImage(
                item.image.asset
              ).url()}&w=640&q=50`,
              colors: item.colors.map((color) => {
                return {
                  color: color.color.hex,
                  ratio: color.ratio,
                };
              }),
            };

            return parsed;
          }
        });
      })
      .flat(2)
      .filter((item): item is Omit<PaletteType, 'index'> => !!item)
      .map((item, index) => {
        return {
          ...item,
          index,
        };
      });
    return data;
  }, [experienceItems]);

  return data;
}
